export const refetchInterval = 20000;
